module.exports = __webpack_public_path__ + "static/media/natemat.2e2ee798.svg";